import { z } from 'zod';
export const customerBillingProfileSchema = z
  .object({
    number_prefix: z.string().nullable().optional(),
    number_suffix: z.string().nullable().optional(),
  })
  .passthrough();
export type CustomerBillingProfile = z.infer<typeof customerBillingProfileSchema>;

import { apiRequest } from '../masterdata/repository';
const entitySchema = z.object({
  id: z.string(),
  entity_code: z.string(),
  number_suffix: z.string(),
});
export async function invoicePreviewSources(cycle: string, signal: AbortSignal) {
  const [settings, entities] = await Promise.all([
    apiRequest(
      `/admin/masterdata/billing-settings?cycle=${encodeURIComponent(cycle)}`,
      'GET',
      undefined,
      signal
    ),
    apiRequest('/admin/masterdata/issuing-entities', 'GET', undefined, signal),
  ]);
  return {
    pattern: z.object({ invoice_number_pattern: z.string() }).parse(settings)
      .invoice_number_pattern,
    entities: entitySchema.array().parse(entities),
  };
}
